import AddMerchantButton from './AddMerchantButton';

export default AddMerchantButton;